import { extendTheme } from '@chakra-ui/react'
import { CustomButton } from './button.theme'
import colors from './colors.theme'
import { breakPointValues } from './globalStyles'
import { CustomInput } from './input.theme'
import { DARK_PAGE_BG } from 'constants/dark-tokens'

// Directly define breakpoints without using createBreakpoints
const breakpoints = breakPointValues

const theme = extendTheme({
  colors,
  breakpoints,
  components: {
    CloseButton: {
      baseStyle: {
        border: 'unset',
        boxShadow: 'unset',
        background: 'white',
        _focus: { borderColor: 'unset' },
        _active: { borderColor: 'unset' }
      },
      sizes: {
        xl: {
          width: 12,
          height: 12
        }
      }
    },
    Text: {
      baseStyle: {
        marginBottom: 0
      }
    },
    Button: CustomButton,
    Input: CustomInput,
    // INFO: Fix modal content not full height on iOS safari
    // More detail: https://github.com/chakra-ui/chakra-ui/issues/4680
    Modal: {
      baseStyle: {
        dialogContainer: {
          '@supports(height: -webkit-fill-available)': {},
          zIndex: 10000
        },
        overlay: {
          zIndex: 10000
        }
      }
    },
    Tooltip: {
      baseStyle: {
        zIndex: 10001
      }
    },
    Checkbox: {
      baseStyle: {
        control: {
          _checked: {
            background: 'primary.500',
            borderColor: 'primary.500'
          },
          _indeterminate: {
            background: 'primary.500',
            borderColor: 'primary.500'
          }
        }
      }
    }
  },
  // TODO: Add focus border color later
  // shadows: {
  //   outline: `0 0 0 3px ${focusBorderColorPrimary}`,
  // },
  styles: {
    global: {
      '*, *::before, *::after': {
        fontFamily: `'Poppins', sans-serif`
      },
      // The document background. Chakra injects its global styles after the SCSS,
      // so this is what actually wins — `white` here was why a light backdrop
      // still showed through wherever a page container did not reach (overscroll,
      // the gutter beside `.content-page`, a route mid-transition). Pages that are
      // still light repaint their own `.content-page`, so they are unaffected.
      'html, body': {
        background: DARK_PAGE_BG
      },
      body: {
        fontFamily: `'Poppins', sans-serif`,
        fontSize: '0.9rem',
        fontWeight: 400,
        lineHeight: 1.5,
        color: '#6c757d'
      }
    }
  },
  fonts: {
    heading: `'Poppins', sans-serif`,
    body: `'Poppins', sans-serif`,
    mono: `'Poppins', sans-serif`,
    // Condensed display face for dashboard banner titles only — narrow enough that
    // a long team name still fits at 48px. Loaded in styles/index.scss.
    display: `'Oswald', sans-serif`
  }
})

export default theme
